/* eslint-disable react/display-name */
import React from 'react';
import styled from 'styled-components';
import { useDrag, useDrop } from 'react-dnd';

import device from 'ui/theme/device';

export const DraggableCard = React.memo(
  ({ id, text, moveCard, findCard, isDraggable = true, type = 'card' }) => {
    const originalIndex = findCard(id).index;

    const [{ isDragging }, drag] = useDrag(
      () => ({
        type,
        item: { id, originalIndex },
        canDrag: () => isDraggable,
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
          const { id: droppedId, originalIndex } = item;
          const didDrop = monitor.didDrop();
          if (!didDrop) {
            moveCard(droppedId, originalIndex);
          }
        },
      }),
      [id, originalIndex, moveCard]
    );

    const [, drop] = useDrop(
      () => ({
        accept: type,
        canDrop: () => false,
        hover({ id: draggedId }) {
          if (draggedId !== id) {
            const { index: overIndex } = findCard(id);
            moveCard(draggedId, overIndex);
          }
        },
      }),
      [findCard, moveCard]
    );

    return (
      <Card ref={(node) => drag(drop(node))} isDragging={isDragging}>
        {text}
      </Card>
    );
  }
);

const Card = styled.div`
  border: 1px dashed #ddd;
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
  cursor: move;
  border-radius: 2px;
  background-color: #f5f9ff;
  color: ${({ theme }) => theme.colors.primary};
  opacity: ${({ isDragging }) => (isDragging ? 0 : 1)};
  font-size: 16px;
  @media ${device.small} {
    font-size: 14px;
  }
`;
